(function () {
  class FiveOAK extends PIXI.Container {
    constructor() {
      super();
    }

    init() {
      this.dimScreen = resourceManager.get('fiveOAKDimObject');
      this.dimScreen.show(false);

      this.fiveOAKContainer = resourceManager.getContainer('fiveOAKContainer');

      this.title = resourceManager.get('fiveOAK:FiveOAK:title');
      this.burst1 = resourceManager.get('fiveOAK:FiveOAK:BurstContainer:Burst1');
      this.burst2 = resourceManager.get('fiveOAK:FiveOAK:BurstContainer:Burst2');
    }

    getFiveOAKPromise() {
      return this.fiveOAKPromise;
    }

    isActive() {
      return this.active;
    }

    async show() {
      let doFiveOAKResolver = null;
      this.fiveOAKPromise = new Promise((resolve) => {
        doFiveOAKResolver = resolve;
      });

      this.active = true;
      this.fiveOAKContainer.visible = true;

      soundManager.play('fiveOAK');

      await this.intro();
      this.pulseTitle();
      await timerManager.delayAsync(1250);
      this.stopPulsingTitle();
      await this.outro();

      this.active = false;
      this.fiveOAKContainer.visible = false;

      doFiveOAKResolver();
      this.fiveOAKPromise = null;
    }

    async intro() {
      this.fadeInDimScreen();
      this.startRotatingBursts();

      await Promise.all([
        this.scaleInBursts(), //
        this.fadeInBursts(),
        this.scaleInTitle(),
        this.rotateTitle(),
      ]);
    }

    async outro() {
      this.fadeOutDimScreen();
      await Promise.all([
        this.scaleOutBursts(), //
        this.fadeOutBursts(),
        this.scaleOutTitle(),
        this.rotateTitle(),
      ]);

      this.stopRotatingBursts();
      this.dimScreen.show(false);
    }

    async fadeInDimScreen() {
      this.dimScreen.show(true);
      this.dimScreen.alpha = 0;
      await Utils.tweenFromToAsync(
        this.dimScreen,
        { alpha: 0 },
        {
          duration: 0.3,
          alpha: 0.6,
        }
      );
    }
    async fadeOutDimScreen() {
      await Utils.tweenFromToAsync(
        this.dimScreen,
        { alpha: 0.6 },
        {
          duration: 0.3,
          alpha: 0,
        }
      );
      this.dimScreen.show(false);
    }

    async fadeAllIn() {
      await Utils.tweenFromToAsync(
        this,
        { alpha: 0 },
        {
          duration: 0.3,
          alpha: 1,
        }
      );
    }

    async scaleInBursts() {
      await Utils.tweenFromToAsync(
        [this.burst1.scale, this.burst2.scale],
        {
          x: 0,
          y: 0,
        },
        {
          x: 1.5,
          y: 1.5,
          duration: 0.5,
        }
      );
    }
    async scaleOutBursts() {
      await Utils.tweenFromToAsync(
        [this.burst1.scale, this.burst2.scale],
        {
          x: 1.5,
          y: 1.5,
        },
        {
          x: 0,
          y: 0,
          duration: 0.5,
        }
      );
    }

    async fadeInBursts() {
      await Promise.all([
        Utils.tweenFromToAsync(
          this.burst1,
          {
            alpha: 0,
          },
          {
            alpha: 0.6,
            duration: 0.5,
          }
        ),
        Utils.tweenFromToAsync(
          this.burst2,
          {
            alpha: 0,
          },
          {
            alpha: 0.5,
            duration: 0.5,
          }
        ),
      ]);
    }
    async fadeOutBursts() {
      await Promise.all([
        Utils.tweenFromToAsync(
          this.burst1,
          {
            alpha: 0.6,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
        Utils.tweenFromToAsync(
          this.burst2,
          {
            alpha: 0.5,
          },
          {
            alpha: 0,
            duration: 0.5,
          }
        ),
      ]);
    }

    async scaleInTitle() {
      this.title.alpha = 1;
      this.title.visible = true;
      await Utils.tweenFromToAsync(
        this.title.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
        }
      );
    }
    async scaleOutTitle() {
      this.title.alpha = 1;
      this.title.visible = true;
      await Utils.tweenFromToAsync(
        this.title.scale,
        {
          x: this.title.scale.x,
          y: this.title.scale.y,
        },
        {
          x: 0,
          y: 0,
          duration: 0.5,
        }
      );
    }

    async rotateTitle() {
      this.title.alpha = 1;
      this.title.visible = true;
      await Utils.tweenFromToAsync(
        this.title,
        {
          rotation: Utils.degreesToRadians(0),
        },
        {
          rotation: Utils.degreesToRadians(359),
          duration: 0.5 / 3,
          repeat: 2,
          ease: 'none',
        }
      );
    }

    startRotatingBursts() {
      this.burst1.rotation = 0;
      this.burst2.rotation = 0;
      this.rotateBurst1Tween = gsap.to(this.burst1, {
        duration: 12,
        rotation: Utils.degreesToRadians(359),
        repeat: -1,
        ease: 'none',
      });
      this.rotateBurst2Tween = gsap.to(this.burst2, {
        duration: 12,
        rotation: Utils.degreesToRadians(-359),
        repeat: -1,
        ease: 'none',
      });
    }

    stopRotatingBursts() {
      if (this.rotateBurst1Tween) {
        this.rotateBurst1Tween.kill();
        this.rotateBurst1Tween = null;
      }
      if (this.rotateBurst2Tween) {
        this.rotateBurst2Tween.kill();
        this.rotateBurst2Tween = null;
      }
    }

    pulseTitle() {
      this.pulseTitleTween = gsap.fromTo(
        this.title.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 0.15,
          repeat: -1,
          yoyo: true,
        }
      );
    }

    stopPulsingTitle() {
      this.pulseTitleTween.kill();
    }

    async scaleOutAndFadeOffTitle(title, listenForSkipWin = false) {
      await Promise.all([
        Utils.tweenFromToAsync(
          title.scale,
          {
            x: title.scale.x,
            y: title.scale.y,
          },
          {
            x: 3,
            y: 3,
            listenForSkipWin: listenForSkipWin,
            duration: 0.75,
          }
        ),
        Utils.tweenFromToAsync(
          title,
          {
            alpha: 1,
          },
          {
            alpha: 0,
            listenForSkipWin: listenForSkipWin,
            duration: 0.5,
          }
        ),
      ]);
    }
  }

  var creator = function (json) {
    return new FiveOAK();
  };

  var initialise = function (json, obj) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('FiveOAK', creator, initialise, filesRequired);
})();
